var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _radialGradient, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconConfetti(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientTransform: "matrix(.706 .708 -.708 .706 -989.657 -180.861)",
    gradientUnits: "userSpaceOnUse",
    x1: 1053.46,
    x2: 1308.866,
    xlinkHref: "#lg1",
    y1: -446.895,
    y2: -401.287
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fba5c2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3857,
    stopColor: "#fca0ba",
    stopOpacity: 0.386
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9737,
    stopColor: "#ff91a5",
    stopOpacity: 0.974
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 189.058,
    x2: 160.679,
    xlinkHref: "#lg2",
    y1: 415.585,
    y2: 516.266
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 217.65,
    x2: 182.513,
    xlinkHref: "#lg2",
    y1: 355.512,
    y2: 482.546
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 241.013,
    x2: 197.092,
    xlinkHref: "#lg2",
    y1: 286.51,
    y2: 431.112
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 266.058,
    x2: 219.434,
    xlinkHref: "#lg1",
    y1: 233.389,
    y2: 338.801
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd00d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#db722b"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 222.045,
    x2: 287.927,
    xlinkHref: "#lg3",
    y1: 313.063,
    y2: 211.707
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 283.177,
    x2: 241.621,
    xlinkHref: "#lg3",
    y1: 268.552,
    y2: 141.856
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 332.406,
    x2: 298.958,
    y1: 338.387,
    y2: 283.654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a34a9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343168"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientTransform: "matrix(.961 .276 -.276 .961 -374.279 -3.357)",
    gradientUnits: "userSpaceOnUse",
    x1: 816.741,
    x2: 795.136,
    xlinkHref: "#lg4",
    y1: 104.448,
    y2: 23.715
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3fa9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666ad6"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientTransform: "matrix(.967 -.255 .255 .967 392.904 -310.331)",
    gradientUnits: "userSpaceOnUse",
    x1: -360.316,
    x2: -344.596,
    xlinkHref: "#lg5",
    y1: 299.54,
    y2: 311.95
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientTransform: "matrix(.611 -.791 .791 .611 1030.861 -459.27)",
    gradientUnits: "userSpaceOnUse",
    x1: -1026.41,
    x2: -1010.69,
    xlinkHref: "#lg4",
    y1: -413.642,
    y2: -401.232
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4974"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4497,
    stopColor: "#fe4773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6292,
    stopColor: "#fc406d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7605,
    stopColor: "#f73464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8683,
    stopColor: "#f12257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9606,
    stopColor: "#e80c46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4003d"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 431.698,
    x2: 383.723,
    xlinkHref: "#lg6",
    y1: 392.08,
    y2: 421.135
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c4f8b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b8eac"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 440.233,
    x2: 417.935,
    xlinkHref: "#lg7",
    y1: 332.545,
    y2: 396.738
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_14_",
    cx: 172.969,
    cy: 36.437,
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    r: 200.758,
    xlinkHref: "#lg6"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg8"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4003d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3434,
    stopColor: "#cd0e2d",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#972e07"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 316.226,
    x2: 243.756,
    xlinkHref: "#lg8",
    y1: 179.284,
    y2: 127.085
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 206.325,
    x2: 226.597,
    xlinkHref: "#lg8",
    y1: 142.125,
    y2: 160.876
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 272.384,
    x2: 305.832,
    xlinkHref: "#lg5",
    y1: 209.862,
    y2: 254.459
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 466.217,
    x2: 499.665,
    xlinkHref: "#lg5",
    y1: 195.568,
    y2: 240.165
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 375.15,
    x2: 408.597,
    xlinkHref: "#lg4",
    y1: 40.9,
    y2: 85.497
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 376.38,
    x2: 400.762,
    xlinkHref: "#lg7",
    y1: 152.303,
    y2: 184.813
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientTransform: "matrix(1 .002 -.002 1 -2.433 .519)",
    gradientUnits: "userSpaceOnUse",
    x1: 407.748,
    x2: 432.13,
    xlinkHref: "#lg1",
    y1: 92.256,
    y2: 124.766
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m375.307 393.752c-1.73 1.724-3.826 3.025-6.271 3.916l-2.467.741s-332.654 134.218-358.52 108.258c-25.866-25.961 109.562-358.124 109.562-358.124l.75-2.464c.9-2.442 2.209-4.533 3.939-6.257 20.693-20.618 94.111 19.508 163.976 89.628s109.724 143.685 89.031 164.302z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m354.611 403.178c-17.507 6.942-52.561 20.683-93.953 36.064-25.316 9.411-53.005 19.435-80.5 28.882-24.027 8.257-47.91 16.089-69.917 22.688-15.12-12.707-30.146-26.489-44.867-41.263s-28.447-29.851-41.099-45.017c6.679-21.982 14.598-45.838 22.943-69.834 9.547-27.461 19.672-55.113 29.175-80.394 15.532-41.336 29.401-76.339 36.406-93.821 44.634 24.204 92.329 59.999 137.239 105.073 44.911 45.075 80.532 92.9 104.573 137.622z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m375.305 393.749c-1.726 1.73-3.827 3.024-6.271 3.921l-2.464.735s-4.301 1.735-11.959 4.772c-17.507 6.942-52.561 20.683-93.953 36.064-25.316 9.411-53.005 19.435-80.5 28.882-23.898-18.024-47.851-38.846-71.06-62.14s-43.943-47.323-61.881-71.286c9.547-27.461 19.672-55.113 29.175-80.394 15.532-41.336 29.401-76.339 36.406-93.821 3.065-7.647 4.816-11.941 4.816-11.941l.744-2.462c.907-2.441 2.208-4.537 3.944-6.257 20.694-20.619 94.105 19.51 163.975 89.624 69.861 70.127 109.722 143.684 89.028 164.303z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m375.305 393.749c-1.726 1.73-3.827 3.024-6.271 3.921l-2.464.735s-4.301 1.735-11.959 4.772c-17.507 6.942-52.561 20.683-93.953 36.064-33.691-22.188-68.203-50.306-101.205-83.429s-60.995-67.737-83.06-101.508c15.532-41.336 29.401-76.339 36.406-93.821 3.065-7.647 4.816-11.941 4.816-11.941l.744-2.462c.907-2.441 2.208-4.537 3.944-6.257 20.694-20.619 94.105 19.51 163.975 89.624 69.86 70.126 109.721 143.683 89.027 164.302z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m375.304 393.755c-20.697 20.622-94.114-19.504-163.979-89.625s-109.725-143.682-89.028-164.305 94.114 19.504 163.979 89.625 109.725 143.683 89.028 164.305z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m362.405 374.853c-15.29 15.235-77.215-22.125-138.312-83.445s-98.231-123.38-82.941-138.615 77.215 22.125 138.312 83.445 98.232 123.38 82.941 138.615z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m375.307 393.752c20.693-20.618-19.165-94.181-89.031-164.301-40.967-41.116-83.15-71.911-115.214-86.202 1.252 2.304 2.649 4.588 4.21 6.84 2.537 3.66 5.507 6.996 8.851 10.004l17.741 17.864c-2.045.928-3.924 1.662-5.504 2.219-2.829.997-4.485 3.923-3.893 6.863l6.278 31.184c.555 2.757 2.489 4.851 4.906 5.766l170.324 170.945c.465-.368.91-.761 1.332-1.182z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m262.055 296.866 17.422 20.827 81.157 81.453c6.203-.175 11.187-1.918 14.671-5.39 18.086-18.021-10.071-76.467-64.083-137.717-16.831 7.029-32.876 16.23-47.693 27.543-4.186 3.194-4.853 9.245-1.474 13.284z",
    fill: "url(#SVGID_8_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m279.477 317.693-17.422-20.827c-3.379-4.039-2.712-10.089 1.473-13.285 53.993-41.222 124.224-54.611 189.815-35.746 16.508 4.747 32.315 11.404 47.111 19.831 4.577 2.607 6.044 8.518 3.232 12.972l-14.494 22.961c-2.628 4.163-8.049 5.523-12.343 3.117-11.357-6.362-23.468-11.411-36.112-15.047-51.295-14.753-106.195-4.459-148.614 27.471-3.932 2.959-9.489 2.327-12.646-1.447z",
    fill: "url(#SVGID_9_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m128.928 101.472-15.819-16.277c-7.17-7.378-9.329-19.254-5.142-28.284 4.861-10.485 16.527-13.558 25.923-6.829 8.093 5.796 12.065 17.194 9.46 27.147l-5.746 21.958c-1.015 3.88-5.88 5.162-8.676 2.285z",
    fill: "url(#SVGID_10_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m100.947 119.148-22.462-3.264c-10.181-1.479-19.131-9.579-21.315-19.29-2.536-11.276 4.84-20.822 16.39-21.213 9.948-.337 20.044 6.278 24.045 15.757l8.827 20.911c1.561 3.695-1.516 7.676-5.485 7.099z",
    fill: "url(#SVGID_11_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m401.689 380.249 22.605-2.046c10.246-.927 20.833 4.87 25.214 13.808 5.087 10.377.132 21.376-11.011 24.442-9.598 2.64-20.954-1.448-27.049-9.737l-13.445-18.287c-2.375-3.232-.309-7.819 3.686-8.18z",
    fill: "url(#SVGID_12_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m405.567 347.38 16.675-15.399c7.558-6.98 19.485-8.835 28.406-4.42 10.358 5.127 13.133 16.867 6.166 26.089-6 7.943-17.496 11.623-27.379 8.766l-21.805-6.304c-3.852-1.114-5.009-6.011-2.063-8.732z",
    fill: "url(#SVGID_13_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m208.759 224.124c-4.423 1.426-9.097-1.344-10.014-5.9l-6.278-31.184c-.592-2.941 1.064-5.866 3.893-6.863 3.306-1.165 7.9-3.082 12.649-6.002-14.343-4.735-26.014-12.945-33.736-24.085-14.558-21.003-15.699-44.677-3.054-63.328 12.513-18.456 35.634-27.46 57.539-22.403 23.947 5.528 40.768 26.481 44.996 56.051.176 1.231.332 2.456.467 3.676 5.875-3.442 10.622-7.688 13.595-12.441 7.526-12.029 8.24-29.981 1.822-45.734-4.074-9.998-10.363-17.644-17.456-21.49-3.164-1.715-4.85-5.274-4.002-8.771l7.192-29.657c1.102-4.542 5.94-7.156 10.305-5.484 20.129 7.709 36.691 24.854 46.2 48.19 11.95 29.328 9.884 62.716-5.393 87.136-12.087 19.32-34.379 33.731-60.155 39.823-5.79 12.106-14.455 22.741-25.82 31.454-12.136 9.302-24.709 14.42-32.75 17.012zm8.94-115.523c-2.983-.005-6.186 1.48-7.728 3.756-2.304 3.398.758 8.821 2.788 11.75 2.784 4.017 9.266 7.014 17.431 8.356-.118-1.818-.314-3.683-.588-5.597-1.457-10.188-5.234-16.941-10.104-18.065-.579-.134-1.184-.199-1.799-.2z",
    fill: "url(#SVGID_14_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m307.915 156.897-32.694-32.813s2.088 31.684-7.893 51.573c15.201-3.592 29.188-10.08 40.587-18.76z",
    fill: "url(#SVGID_15_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m212.759 124.107c-1.487-2.146-3.519-5.627-3.599-8.673l-45.672-.083c.071 11.561 4.016 23.53 11.785 34.739 7.722 11.141 19.392 19.351 33.736 24.085 0 0 23.408-7.101 21.182-41.712-8.166-1.342-14.648-4.339-17.432-8.356z",
    fill: "url(#SVGID_16_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m309.607 227.979c-10.602 6.909-19.649 16.01-26.499 26.656-1.541 2.394-5.096 2.388-6.628-.012-6.812-10.671-15.824-19.805-26.402-26.753-2.348-1.542-2.341-5.049.012-6.582 10.602-6.909 19.648-16.01 26.499-26.656 1.54-2.394 5.096-2.388 6.628.012 6.812 10.671 15.825 19.805 26.402 26.753 2.348 1.542 2.341 5.049-.012 6.582z",
    fill: "url(#SVGID_17_)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m503.466 214.039c-10.602 6.909-19.649 16.01-26.499 26.656-1.54 2.394-5.096 2.388-6.628-.012-6.812-10.671-15.824-19.805-26.402-26.753-2.348-1.542-2.341-5.049.012-6.582 10.602-6.909 19.648-16.01 26.499-26.656 1.54-2.394 5.096-2.388 6.628.012 6.812 10.671 15.825 19.805 26.402 26.753 2.348 1.541 2.341 5.048-.012 6.582z",
    fill: "url(#SVGID_18_)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m412.68 59.204c-10.602 6.909-19.649 16.01-26.499 26.656-1.541 2.394-5.096 2.388-6.628-.012-6.812-10.671-15.824-19.805-26.402-26.753-2.348-1.542-2.341-5.049.012-6.582 10.602-6.909 19.648-16.01 26.499-26.656 1.54-2.394 5.096-2.388 6.628.012 6.812 10.671 15.825 19.805 26.402 26.753 2.348 1.542 2.341 5.049-.012 6.582z",
    fill: "url(#SVGID_19_)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m402.855 165.974c-7.729 5.037-14.323 11.671-19.317 19.431-1.123 1.745-3.715 1.74-4.831-.009-4.965-7.779-11.535-14.437-19.246-19.502-1.711-1.124-1.707-3.68.009-4.798 7.729-5.037 14.323-11.671 19.317-19.431 1.123-1.745 3.715-1.741 4.831.009 4.966 7.779 11.536 14.437 19.246 19.502 1.712 1.124 1.707 3.68-.009 4.798z",
    fill: "url(#SVGID_20_)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m434.333 105.985c-7.729 5.037-14.323 11.671-19.317 19.431-1.123 1.745-3.715 1.74-4.831-.009-4.965-7.779-11.535-14.437-19.246-19.502-1.711-1.124-1.707-3.68.009-4.798 7.729-5.037 14.323-11.671 19.317-19.431 1.123-1.745 3.715-1.741 4.831.009 4.966 7.779 11.536 14.437 19.246 19.502 1.711 1.124 1.706 3.68-.009 4.798z",
    fill: "url(#SVGID_21_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfetti);
export default __webpack_public_path__ + "static/media/icon-confetti.3a78db48f4342f89fc12dba51b1ce19a.svg";
export { ForwardRef as ReactComponent };